
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import DnsZones from './pages/dns/DnsZones';
import DnsRecords from './pages/dns/DnsRecords';
import DnsCidr from './pages/dns/DnsCidr';
import DnsNodes from './pages/dns/DnsNodes';
import DnsPlacement from './pages/dns/DnsPlacement';
import DnsCidrEntries from './pages/dns/DnsCidrEntries';
import DnsBanlist from './pages/dns/DnsBanlist';
import DnsAnalytics from './pages/dns/DnsAnalytics';
import CdnIpPool from './pages/cdn/IpPool';
import CdnProbeVantages from './pages/cdn/ProbeVantages';
import CdnOriginQuality from './pages/cdn/OriginQuality';
import CdnOriginRoutes from './pages/cdn/OriginRoutes';
import CdnAnycast from './pages/cdn/Anycast';
import CdnGlobalProbe from './pages/cdn/GlobalProbe';
import { Domains as CdnDomains, Analytics as CdnAnalytics, Nodes as CdnNodes, NodeSyncStatus as CdnNodeSyncStatus, NodeGroups as CdnNodeGroups, CdnGroups, CdnLines, CdnLineRecords, CdnDnsSync, Topology as CdnTopology } from './pages/cdn';
import CdnDomainDetail from './pages/cdn/DomainDetail';
import CdnOverview from './pages/cdn/Overview';
import CdnOriginSettings from './pages/cdn/OriginSettings';
import CdnSslSettings from './pages/cdn/SslSettings';
import CdnPageRules from './pages/cdn/PageRules';
import CdnCacheSettings from './pages/cdn/CacheSettings';
import CdnDomainSettings from './pages/cdn/DomainSettings';
import CdnErrorPages from './pages/cdn/ErrorPages';
import CdnDiagnostics from './pages/cdn/Diagnostics';
import CdnPlan from './pages/cdn/Plan';
import CdnFirewall from './pages/cdn/Firewall';
import CdnOptimization from './pages/cdn/Optimization';
import CdnNetwork from './pages/cdn/Network';
import CdnTraffic from './pages/cdn/Traffic';
import CdnWorker from './pages/cdn/Worker';
import CdnWorkers from './pages/cdn/Workers';
import CdnWorkerDetail from './pages/cdn/WorkerDetail';
import WafRulesets from './pages/cdn/WafRulesets';
import GlobalRules from './pages/cdn/GlobalRules';
import CrsRules from './pages/cdn/CrsRules';
import OpsAlerts from './pages/cdn/OpsAlerts';
import CdnBanlist from './pages/cdn/Banlist';
import Settings from './pages/Settings';
import UserManagement from './pages/UserManagement';
import AbuseProtection from './pages/users/AbuseProtection';
import UserDetailRoute from './pages/users/UserDetailRoute';
import Products from './pages/billing/Products';
import Subscriptions from './pages/billing/Subscriptions';
import Invoices from './pages/billing/Invoices';
import Currencies from './pages/billing/Currencies';
import Quotas from './pages/billing/Quotas';
import Coupons from './pages/billing/Coupons';
import AffiliateAdmin from './pages/billing/Affiliate';
import S3Admin from './pages/s3/S3Admin';
import SitesAdmin from './pages/sites/SitesAdmin';
import SitesMarketingAdmin from './pages/sites/SitesMarketingAdmin';
import Registrars from './pages/domain/Registrars';
import TldPricing from './pages/domain/TldPricing';
import DomainPricing from './pages/domain/DomainPricing';
import DomainManagement from './pages/domain/DomainManagement';
import UserDomains from './pages/domain/UserDomains';
import ContactTemplates from './pages/domain/ContactTemplates';
import RegistrantVerification from './pages/domain/RegistrantVerification';
import DomainDetail from './pages/domain-registration/DomainDetail';
import { JobLogs, OrderLogs, SystemLogs, TransferLogs } from './pages/logs';
import SslProviders from './pages/ssl/SslProviders';
import SslProducts from './pages/ssl/SslProducts';
import SslOrders from './pages/ssl/SslOrders';
import CodeSigningProducts from './pages/ssl/CodeSigningProducts';
import { Nodes as HostSharedNodes, Vhosts as HostSharedVhosts, Statistics as HostSharedStatistics, VhostDetail as HostSharedVhostDetail, WebappApps as HostSharedWebappApps, Pending as HostSharedPending } from './pages/host-shared';
import { VmsManagement, VmsDetail, NodeManagement, ZoneManagement, VpcManagement, IpPoolManagement, EipManagement, SecurityGroupManagement, ImageManagement, ProductManagement, TemplateManagement, StartupScriptManagement, PortForwardManagement, Topology as EvmTopology, SubscriptionManagement as EvmSubscriptionManagement, StoragePoolManagement as EvmStoragePoolManagement, CephClusterManagement as EvmCephClusterManagement } from './pages/evm';
import EvmNodeMonitor from './pages/evm/NodeMonitor';
import EvmBgpAdmin from './pages/evm/BgpAdmin';
import EvmBackupManagement from './pages/evm/BackupManagement';
import EvmQuotaReport from './pages/evm/QuotaReport';
import EvmOvercommit from './pages/evm/Overcommit';
import EvmVdsNodes from './pages/evm/VdsNodes';
import EvmPendingProvisions from './pages/evm/PendingProvisions';
import EvmContainerManagement from './pages/evm/ContainerManagement';
import DedicatedManagement from './pages/dedicated/DedicatedManagement';
import EvmVpcPeeringAdmin from './pages/evm/VpcPeeringAdmin';
import DnsTopology from './pages/dns/Topology';
import BlogManager from './pages/BlogManager';
import { Endpoints as LightappEndpoints, Templates as LightappTemplates, Services as LightappServices, Registry as LightappRegistry, Products as LightappProducts, TemplateGroups as LightappTemplateGroups } from './pages/lightapp';
import SslStats from './pages/ssl/SslStats';
import { Streams as TmStreams, Nodes as TmNodes, Groups as TmGroups, Suppressions as TmSuppressions, Overview as TmOverview, Risk as TmRisk, Messages as TmMessages, Domains as TmDomains, ApiKeys as TmApiKeys, Settings as TmSettings, Marketing as TmMarketing } from './pages/tm';
import LlmUsers from './pages/llm/Users';
import { Overview as DiskOverview, Accounts as DiskAccounts, Orgs as DiskOrgs, Shares as DiskShares, Links as DiskLinks, Settings as DiskSettings } from './pages/disk';
import { RateLimitSettings, SystemHealth, SystemSettings, SettingsHub, CdnGlobalSettings, Processes, Failures } from './pages/system';
import DocsManager from './pages/DocsManager';
import DocsEditor from './pages/DocsEditor';
import BlogPostEditor from './pages/BlogPostEditor';
import { Clusters as WebmailClusters, Nodes as WebmailNodes, Domains as WebmailDomains, Users as WebmailUsers, Rules as WebmailRules, Blacklist as WebmailBlacklist, Settings as WebmailSettings, Aliases as WebmailAliases, Stats as WebmailStats, SpamReports as WebmailSpamReports } from './pages/webmail';
import NodeManager from './pages/node/NodeManager';
import ComponentVersions from './pages/node/ComponentVersions';
import { Tickets as SupportTickets, TicketDetail as SupportTicketDetail, Departments as SupportDepartments } from './pages/support';

import { AuthProvider } from '../shared/contexts/AuthContext';
import PrivateRoute from '../shared/components/PrivateRoute';
import Login from '../shared/pages/Login';
import Register from '../shared/pages/Register';
import ResetPassword from '../shared/pages/ResetPassword';
import CaptchaModal from '../shared/components/CaptchaModal';
import { adminPath } from '../shared/config/paths';

const AdminRoutes = () => (
    <AdminLayout>
        <Routes>
            <Route path="dashboard" element={<Dashboard />} />
                <Route path="dns">
                    <Route index element={<Navigate to="zones" replace />} />
                    <Route path="zones" element={<DnsZones />} />
                    <Route path="records/:zoneId" element={<DnsRecords />} />
                    <Route path="cidr" element={<DnsCidr />} />
                    <Route path="cidr/:cidrId" element={<DnsCidrEntries />} />
                    <Route path="nodes" element={<DnsNodes />} />
                    <Route path="banlist" element={<DnsBanlist />} />
                    <Route path="analytics" element={<DnsAnalytics />} />
                    <Route path="topology" element={<DnsTopology />} />
                    <Route path="placement" element={<DnsPlacement />} />
                </Route>
                <Route path="cdn">
                    <Route index element={<Navigate to="domains" replace />} />
                    <Route path="domains" element={<CdnDomains />} />
                    <Route path="domains/:domainId" element={<CdnDomainDetail />}>
                        <Route index element={<CdnOverview />} />
                        <Route path="origin" element={<CdnOriginSettings />} />
                        <Route path="ssl" element={<CdnSslSettings />} />
                        <Route path="firewall" element={<CdnFirewall />} />
                        <Route path="rules" element={<CdnPageRules />} />
                        <Route path="cache" element={<CdnCacheSettings />} />
                        <Route path="optimization" element={<CdnOptimization />} />
                        <Route path="network" element={<CdnNetwork />} />
                        <Route path="traffic" element={<CdnTraffic />} />
                        <Route path="worker" element={<CdnWorker />} />
                        <Route path="error-pages" element={<CdnErrorPages />} />
                        <Route path="diagnostics" element={<CdnDiagnostics />} />
                        <Route path="plan" element={<CdnPlan />} />
                        <Route path="settings" element={<CdnDomainSettings />} />
                    </Route>
                    <Route path="workers" element={<CdnWorkers />} />
                    <Route path="workers/:workerId" element={<CdnWorkerDetail />} />
                    <Route path="analytics" element={<CdnAnalytics />} />
                    <Route path="nodes" element={<CdnNodes />} />
                    <Route path="ip-pool" element={<CdnIpPool />} />
                    <Route path="probe-vantages" element={<CdnProbeVantages />} />
                    <Route path="origin-quality" element={<CdnOriginQuality />} />
                    <Route path="origin-routes" element={<CdnOriginRoutes />} />
                    <Route path="anycast" element={<CdnAnycast />} />
                    <Route path="global-probe" element={<CdnGlobalProbe />} />
                    <Route path="node-sync-status" element={<CdnNodeSyncStatus />} />
                    <Route path="node-groups" element={<CdnNodeGroups />} />
                    <Route path="groups" element={<CdnGroups />} />
                    <Route path="lines" element={<CdnLines />} />
                    <Route path="line-records" element={<CdnLineRecords />} />
                    <Route path="dns-sync" element={<CdnDnsSync />} />
                    <Route path="waf-rulesets" element={<WafRulesets />} />
                    <Route path="global-rules" element={<GlobalRules />} />
                    <Route path="crs" element={<CrsRules />} />
                    <Route path="ops-alerts" element={<OpsAlerts />} />
                    <Route path="banlist" element={<CdnBanlist />} />
                    <Route path="topology" element={<CdnTopology />} />
                </Route>
                <Route path="billing">
                    <Route index element={<Navigate to="products" replace />} />
                    <Route path="products" element={<Products />} />
                    <Route path="subscriptions" element={<Subscriptions />} />
                    <Route path="invoices" element={<Invoices />} />
                    <Route path="currencies" element={<Currencies />} />
                    <Route path="quotas" element={<Quotas />} />
                    <Route path="coupons" element={<Coupons />} />
                    <Route path="affiliate" element={<AffiliateAdmin />} />
                </Route>
                <Route path="domain-registration">
                    <Route index element={<Navigate to="registrars" replace />} />
                    <Route path="registrars" element={<Registrars />} />
                    <Route path="tld-pricing" element={<TldPricing />} />
                    <Route path="pricing" element={<DomainPricing />} />
                    <Route path="domains" element={<DomainManagement />} />
                    <Route path="users" element={<UserDomains />} />
                    <Route path="contact-templates" element={<ContactTemplates />} />
                    <Route path="verification" element={<RegistrantVerification />} />
                    <Route path="detail/:domainId" element={<DomainDetail />} />
                </Route>
                <Route path="ssl">
                    <Route index element={<Navigate to="providers" replace />} />
                    <Route path="providers" element={<SslProviders />} />
                    <Route path="products" element={<SslProducts />} />
                    <Route path="codesigning" element={<CodeSigningProducts />} />
                    <Route path="orders" element={<SslOrders />} />
                    <Route path="stats" element={<SslStats />} />
                </Route>
                <Route path="host">
                    {/* 旧版容器已并入 独享容器 */}
                    <Route index element={<Navigate to={adminPath("/evm/containers/list")} replace />} />
                    <Route path="nodes" element={<Navigate to={adminPath("/evm/containers/nodes")} replace />} />
                    <Route path="*" element={<Navigate to={adminPath("/evm/containers/list")} replace />} />
                </Route>
                <Route path="host-shared">
                    <Route index element={<Navigate to="nodes" replace />} />
                    <Route path="nodes" element={<HostSharedNodes />} />
                    <Route path="vhosts" element={<HostSharedVhosts />} />
                    <Route path="vhosts/:id" element={<HostSharedVhostDetail />} />
                    <Route path="statistics" element={<HostSharedStatistics />} />
                    <Route path="webapp-apps" element={<HostSharedWebappApps />} />
                    <Route path="pending" element={<HostSharedPending />} />
                </Route>
                <Route path="webmail">
                    <Route index element={<Navigate to="clusters" replace />} />
                    <Route path="clusters" element={<WebmailClusters />} />
                    <Route path="nodes" element={<WebmailNodes />} />
                    <Route path="domains" element={<WebmailDomains />} />
                    <Route path="users" element={<WebmailUsers />} />
                    <Route path="aliases" element={<WebmailAliases />} />
                    <Route path="stats" element={<WebmailStats />} />
                    <Route path="rules" element={<WebmailRules />} />
                    <Route path="blacklist" element={<WebmailBlacklist />} />
                    <Route path="spam-reports" element={<WebmailSpamReports />} />
                    <Route path="settings" element={<WebmailSettings />} />
                </Route>
                <Route path="evm">
                    <Route index element={<Navigate to="vms" replace />} />
                    <Route path="vms" element={<VmsManagement />} />
                    <Route path="vms/:id" element={<VmsDetail />} />
                    <Route path="subscriptions" element={<EvmSubscriptionManagement />} />
                    <Route path="nodes" element={<NodeManagement />} />
                    <Route path="zones" element={<ZoneManagement />} />
                    <Route path="vpc" element={<VpcManagement />} />
                    <Route path="vpc-peering" element={<EvmVpcPeeringAdmin />} />
                    <Route path="ip-pools" element={<IpPoolManagement />} />
                    <Route path="storage-pools" element={<EvmStoragePoolManagement />} />
                    <Route path="ceph" element={<EvmCephClusterManagement />} />
                    <Route path="eips" element={<EipManagement />} />
                    <Route path="security-groups" element={<SecurityGroupManagement />} />
                    <Route path="images" element={<ImageManagement />} />
                    <Route path="products" element={<ProductManagement />} />
                    <Route path="templates" element={<TemplateManagement />} />
                    <Route path="startup-scripts" element={<StartupScriptManagement />} />
                    <Route path="port-forward" element={<PortForwardManagement />} />
                    <Route path="topology" element={<EvmTopology />} />
                    <Route path="monitor" element={<EvmNodeMonitor />} />
                    <Route path="bgp" element={<EvmBgpAdmin />} />
                    <Route path="backups" element={<EvmBackupManagement />} />
                    <Route path="quota" element={<EvmQuotaReport />} />
                    <Route path="overcommit" element={<EvmOvercommit />} />
                    <Route path="vds" element={<EvmVdsNodes />} />
                    <Route path="pending" element={<EvmPendingProvisions />} />
                    <Route path="containers" element={<Navigate to={adminPath("/evm/containers/list")} replace />} />
                    <Route path="containers/:tab" element={<EvmContainerManagement />} />
                </Route>
                <Route path="dedicated" element={<DedicatedManagement />} />
                <Route path="lightapp">
                    <Route index element={<Navigate to="services" replace />} />
                    <Route path="endpoints" element={<LightappEndpoints />} />
                    <Route path="templates" element={<LightappTemplates />} />
                    <Route path="services" element={<LightappServices />} />
                    <Route path="registries" element={<LightappRegistry />} />
                    <Route path="products" element={<LightappProducts />} />
                    <Route path="template-groups" element={<LightappTemplateGroups />} />
                </Route>
                <Route path="tm">
                    <Route index element={<Navigate to="overview" replace />} />
                    <Route path="overview" element={<TmOverview />} />
                    <Route path="streams" element={<TmStreams />} />
                    <Route path="risk" element={<TmRisk />} />
                    <Route path="marketing" element={<TmMarketing />} />
                    <Route path="messages" element={<TmMessages />} />
                    <Route path="domains" element={<TmDomains />} />
                    <Route path="api-keys" element={<TmApiKeys />} />
                    <Route path="settings" element={<TmSettings />} />
                    <Route path="nodes" element={<TmNodes />} />
                    <Route path="groups" element={<TmGroups />} />
                    <Route path="suppressions" element={<TmSuppressions />} />
                </Route>
                <Route path="s3">
                    <Route index element={<S3Admin />} />
                    <Route path=":tab" element={<S3Admin />} />
                </Route>
                <Route path="sites">
                    <Route index element={<Navigate to="list" replace />} />
                    <Route path="marketing" element={<SitesMarketingAdmin />} />
                    <Route path=":tab" element={<SitesAdmin />} />
                    <Route path=":tab/:id" element={<SitesAdmin />} />
                </Route>
                <Route path="disk">
                    <Route index element={<Navigate to="overview" replace />} />
                    <Route path="overview" element={<DiskOverview />} />
                    <Route path="accounts" element={<DiskAccounts />} />
                    <Route path="orgs" element={<DiskOrgs />} />
                    <Route path="shares" element={<DiskShares />} />
                    <Route path="links" element={<DiskLinks />} />
                    <Route path="settings" element={<DiskSettings />} />
                </Route>
                <Route path="llm">
                    <Route index element={<Navigate to="users" replace />} />
                    <Route path="users" element={<LlmUsers />} />
                </Route>
                {/* 顶层「数据分析」与 /dns/analytics 是同一页（DnsAnalytics），菜单重组后合并：旧地址重定向 */}
                <Route path="analytics" element={<Navigate to={adminPath("/dns/analytics")} replace />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="users/abuse" element={<AbuseProtection />} />
                {/* 用户详情直达（命令面板 / 其它页面的用户链接）；/users/detail/:id 是仪表盘的旧链接 */}
                <Route path="users/:id" element={<UserDetailRoute />} />
                <Route path="users/detail/:id" element={<UserDetailRoute />} />
                <Route path="support">
                    <Route index element={<Navigate to="tickets" replace />} />
                    <Route path="tickets" element={<SupportTickets />} />
                    <Route path="tickets/:id" element={<SupportTicketDetail />} />
                    <Route path="departments" element={<SupportDepartments />} />
                </Route>
                <Route path="logs">
                    <Route index element={<Navigate to="jobs" replace />} />
                    <Route path="jobs" element={<JobLogs />} />
                    <Route path="orders" element={<OrderLogs />} />
                    <Route path="system" element={<SystemLogs />} />
                    <Route path="transfers" element={<TransferLogs />} />
                </Route>
                <Route path="docs" element={<DocsManager />} />
                <Route path="docs/new" element={<DocsEditor />} />
                <Route path="docs/:id/edit" element={<DocsEditor />} />
                <Route path="blog" element={<BlogManager />} />
                <Route path="blog/new" element={<BlogPostEditor />} />
                <Route path="blog/:id/edit" element={<BlogPostEditor />} />
                <Route path="system">
                    <Route index element={<Navigate to="settings" replace />} />
                    {/* 系统设置首页：全部全局设置的搜索/分组索引（原「动态设置」移到 legacy-settings，只读） */}
                    <Route path="settings" element={<SettingsHub />} />
                    <Route path="cdn" element={<CdnGlobalSettings />} />
                    <Route path="legacy-settings" element={<SystemSettings />} />
                    <Route path="rate-limit" element={<RateLimitSettings />} />
                    <Route path="health" element={<SystemHealth />} />
                    <Route path="processes" element={<Processes />} />
                    <Route path="failures" element={<Failures />} />
                </Route>
                <Route path="node" element={<NodeManager />} />
                <Route path="node/components" element={<ComponentVersions />} />
                <Route path="settings" element={<Settings />} />
                <Route path="*" element={<Navigate to={adminPath("/dashboard")} replace />} />
            </Routes>
    </AdminLayout>
);

const AdminApp = () => {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/*" element={
                    <PrivateRoute allowedRoles={['admin']}>
                        <AdminRoutes />
                    </PrivateRoute>
                } />
            </Routes>
            <CaptchaModal />
        </AuthProvider>
    );
};

export default AdminApp;
